import { FastForwardIcon } from "@/components/icons";

interface UnboxingSkipButtonProps {
  onSkip: () => void;
  isMobile: boolean;
}

/**
 * "Skip video" pill pinned bottom-right over the unboxing video (recipient route only). Same
 * visual language as UnboxingCtaButton, on translucent white so it reads over any frame.
 */
export default function UnboxingSkipButton({ onSkip, isMobile }: UnboxingSkipButtonProps) {
  return (
    <button
      type="button"
      aria-label="Skip video"
      onClick={onSkip}
      className={[
        "absolute inline-flex items-center justify-center gap-2 font-lato text-[14px] font-bold tracking-[0.5px] uppercase",
        "border-2 border-rodeo-black bg-white/85 text-rodeo-black select-none cursor-pointer",
        "transition-colors duration-150 hover:bg-white",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-rodeo-black focus-visible:ring-offset-2",
      ].join(" ")}
      style={{
        right: isMobile ? 16 : 24,
        bottom: "calc(24px + env(safe-area-inset-bottom))",
        zIndex: 10,
        minWidth: 44,
        minHeight: 44,
        padding: "0 20px",
        borderRadius: 24,
      }}
    >
      Skip
      <FastForwardIcon width={18} height={18} />
    </button>
  );
}
